import type { RfqBucket } from "../types";

export interface RfqBucketMeta {
  key: RfqBucket;
  label: string;
  empty: string;
}

export const RFQ_BUCKETS: RfqBucketMeta[] = [
  { key: "open", label: "New RFQs", empty: "No new RFQs right now. New requests from Livspace will appear here." },
  { key: "submitted", label: "Submitted", empty: "No responses under evaluation." },
  { key: "closed", label: "Closed", empty: "No allotted, expired or declined RFQs yet." },
];

export const DEFAULT_BUCKET: RfqBucket = "open";
export const RFQ_PAGE_SIZE = 10;

export function isRfqBucket(value: string | null | undefined): value is RfqBucket {
  return RFQ_BUCKETS.some((bucket) => bucket.key === value);
}

export function bucketMeta(key: RfqBucket): RfqBucketMeta {
  return RFQ_BUCKETS.find((bucket) => bucket.key === key) as RfqBucketMeta;
}
